const BUSINESS_TYPES = [
  {
    label: "Agricultural Merchant / Farm Store",
    value: "Agricultural Merchant / Farm Store",
    id: "agricultural_merchant_farm_store",
  },
  {
    label: "Animal Shelter / Charity",
    value: "Animal Shelter / Charity",
    id: "animal_shelter_charity",
  },
  {
    label: "Backgrounder Lot",
    value: "Backgrounder Lot",
    id: "backgrounder_lot",
  },
  {
    label: "Beef Producer",
    value: "Beef Producer",
    id: "beef_producer",
  },
  { label: "Broilers", value: "Broilers", id: "broilers" },
  {
    label: "Buying Group",
    value: "Buying Group",
    id: "buying_group",
  },
  {
    label: "Calf Production",
    value: "Calf Production",
    id: "calf_production",
  },
  {
    label: "Calf Ranch/Developer",
    value: "Calf Ranch/Developer",
    id: "calf_ranch_developer",
  },
  { label: "Cattle Buyer", value: "Cattle Buyer", id: "cattle_buyer" },
  {
    label: "Contract Grower",
    value: "Contract Grower",
    id: "contract_grower",
  },
  { label: "Cooperative", value: "Cooperative", id: "cooperative" },
  {
    label: "Văn phòng công ty",
    value: "Corporate Office",
    id: "corporate_office",
  },
  {
    label: "Cow/Calf Operation",
    value: "Cow/Calf Operation",
    id: "cow_calf_operation",
  },
  {
    label: "Dairy Production",
    value: "Dairy Production",
    id: "dairy_production",
  },
  {
    label: "Distributor / Agent",
    value: "Distributor / Agent",
    id: "distributor_agent",
  },
  { label: "Feed Mill", value: "Feed Mill", id: "feed_mill" },
  { label: "Feedyard", value: "Feedyard", id: "feedyard" },
  {
    label: "Grower/Growyard",
    value: "Grower/Growyard",
    id: "grower_growyard",
  },
  { label: "Hatchery", value: "Hatchery", id: "hatchery" },
  {
    label: "Heifer Production",
    value: "Heifer Production",
    id: "heifer_production",
  },
  {
    label: "Layer Integration",
    value: "Layer Integration",
    id: "layer_integration",
  },
  { label: "Layers", value: "Layers", id: "layers" },
  { label: "Media", value: "Media", id: "media" },
  {
    label: "Milk Cooperative/Buyer",
    value: "Milk Cooperative/Buyer",
    id: "milk_cooperative_buyer",
  },
  {
    label: "Mixed/Other Producer",
    value: "Mixed/Other Producer",
    id: "mixed_other_producer",
  },
  {
    label: "Nutrient Supplier",
    value: "Nutrient Supplier",
    id: "nutrient_supplier",
  },
  {
    label: "Packer/Processor",
    value: "Packer/Processor",
    id: "packer_processor",
  },
  {
    label: "Pet Retail Outlet",
    value: "Pet Retail Outlet",
    id: "pet_retail_outlet",
  },
  { label: "Pharmacy", value: "Pharmacy", id: "pharmacy" },
  {
    label: "Poultry Breeder",
    value: "Poultry Breeder",
    id: "poultry_breeder",
  },
  {
    label: "Poultry Integrator",
    value: "Poultry Integrator",
    id: "poultry_integrator",
  },
  { label: "Sheep Producer", value: "Sheep Producer", id: "sheep_producer" },
  {
    label: "Stocker Operation",
    value: "Stocker Operation",
    id: "stocker_operation",
  },
  {
    label: "Stockyard/Salebarn",
    value: "Stockyard/Salebarn",
    id: "stockyard_salebarn",
  },
  { label: "Swine Producer", value: "Swine Producer", id: "swine_producer" },
  { label: "Turkeys", value: "Turkeys", id: "turkeys" },
  {
    label: "University / Education",
    value: "University / Education",
    id: "university_education",
  },
  {
    label: "Phòng khám thú y",
    value: "Veterinary Practice",
    id: "veterinary_practice",
  },
  {
    label: "Wholesaler / Retailer",
    value: "Wholesaler / Retailer",
    id: "wholesaler_retailer",
  },
  { label: "Wool Buyer", value: "Wool Buyer", id: "wool_buyer" },
];

const FIELDS = {
  common: {
    errors: {
      required: "Bắt buộc",
    },
  },
  salutation: {
    label: "Xưng hô",
    placeholder: "Chọn xưng hô",
    errors: {
      required: "Xưng hô là bắt buộc",
      invalid: "Chọn xưng hô hợp lệ",
    },
  },
  firstName: {
    label: "Tên",
    placeholder: "Nguyễn Văn",
    errors: {
      required: "Tên là bắt buộc",
      minLength: "Tên phải tối thiểu 2 ký tự",
      maxLength: "Tên phải tối đa 50 ký tự",
    },
  },
  lastName: {
    label: "Họ",
    placeholder: "An",
    errors: {
      required: "Họ là bắt buộc",
      minLength: "Họ phải tối thiểu 2 ký tự",
      maxLength: "Họ phải tối đa 50 ký tự",
    },
  },
  email: {
    label: "Email",
    placeholder: "nguyen.van.an@example.com",
    description:
      "Nhập địa chỉ email cá nhân của bạn, không phải địa chỉ email được chia sẻ.",
    prefixWarningTitle: "Đã phát hiện hộp thư được chia sẻ",
    prefixWarningDescription:
      "Chúng tôi khuyến nghị sử dụng địa chỉ email cá nhân để có trải  nghiệm tốt hơn và cá nhân hóa hơn",
    errors: {
      required: "Email là bắt buộc",
      invalidEmail: "Nhập địa chỉ email hợp lệ",
      emailAssociatedWithYourAccount:
        "Địa chỉ email của bạn đã được liên kết với tài khoản của bạn và không thể thay đổi.",
    },
  },
  confirmEmail: {
    label: "Xác nhận email",
    placeholder: "nguyen.van.an@example.com",
    errors: {
      required: "Xác nhận email là bắt buộc",
      invalidEmail: "Nhập địa chỉ email hợp lệ",
      emailMatchError: "Địa chỉ email không khớp",
    },
  },
  password: {
    label: "Mật khẩu",
    placeholder: "Nhập mật khẩu của bạn",
    errors: {
      required: "Mật khẩu là bắt buộc",
    },
  },
  confirmPassword: {
    label: "Xác nhận mật khẩu",
    placeholder: "Xác nhận mật khẩusi",
    errors: {
      required: "Xác nhận mật khẩu là bắt buộc",
      passwordMatchError: "Mật khẩu không khớp",
    },
  },
  addressLine1: {
    label: "Dòng địa chỉ 1",
    placeholder: "123 Đường Lê Lợi",
    errors: {
      required: "Dòng địa chỉ 1 là bắt buộc",
      minLength: "Dòng địa chỉ 1 phải có ít nhất 5 ký tự",
      maxLength: "Dòng địa chỉ 1 phải tối đa 100 ký tự",
    },
  },
  addressLine2: {
    label: "Dòng địa chỉ 2",
    placeholder: "Căn 4B",
    errors: {
      required: "Dòng địa chỉ 2 là bắt buộc",
      maxLength: "Dòng địa chỉ 2 phải tối đa 100 ký tự",
    },
  },
  city: {
    label: "Thành phố",
    placeholder: "Hà Nội",
    errors: {
      required: "Thành phố là bắt buộc",
      minLength: "Thành phố on oltava tối thiểu 2 ký tự",
      maxLength: "Thành phố on oltava tối đa 50 ký tự",
    },
  },
  state: {
    label: "Tiền",
    placeholder: "Chọn tiểu bang",
    errors: {
      required: "Tiền là bắt buộc",
      invalid: "Chọn tiểu bang hợp lệ",
    },
  },
  jurisdiction: {
    label: "Phạm vi quyền hạn",
    placeholder: "Chọn phạm vi quyền hạn",
    errors: {
      required: "Phạm vi quyền hạn là bắt buộc",
      invalid: "Chọn phạm vi quyền hạn hợp lệ",
    },
  },
  zipCode: {
    label: "Mã bưu điện",
    placeholder: "100000",
    errors: {
      required: "Mã bưu điện là bắt buộc",
      invalid: "Nhập mã bưu điện hợp lệ",
    },
  },
  role: {
    label: "Vai trò",
    placeholder: "Chọn vai trò của bạn",
    errors: {
      required: "Chọn vai trò của bạn",
      invalid: "Chọn vai trò hợp lệ",
    },
  },
  businessType: {
    label: "Loại hình kinh doanh",
    placeholder: "Chọn loại hình doanh nghiệp",
    errors: {
      required: "Loại hình kinh doanh là bắt buộc",
      invalid: "Chọn loại hình doanh nghiệp hợp lệ",
    },
  },
  businessName: {
    label: "Tên doanh nghiệp",
    placeholder: "Nhập tên doanh nghiệp",
    errors: {
      required: "Tên doanh nghiệp là bắt buộc",
      minLength: "Tên doanh nghiệp phải tối thiểu 2 ký tự",
      maxLength: "Tên doanh nghiệp phải tối đa 100 ký tự",
    },
  },
  businessSearch: {
    label: "Tìm kiếm doanh nghiệp:",
    addNewAccount: "Thêm tài khoản doanh nghiệp mới",
    canNotFindBusiness: "Không tìm thấy doanh nghiệp của bạn?",
    guideline: "Nhập mã bưu điện của bạn, sau đó chọn từ danh sách bên dưới.",
    guidelineForNameSearch:
      "Nhập tên đầy đủ của doanh nghiệp, sau đó chọn từ danh sách.",
    placeholder: "Bạn làm việc ở đâu?",
    noResults: "Không tìm thấy kết quả",
    searching: "Đang tìm kiếm...",
    selectedBusinessHeading: "Doanh nghiệp đã chọn:",
    selectedBusinessNotCorrect: "Không đúng?",
    selectedBusinessTryAgain: "Thử lại",
    selectedBusinessDismiss: "Từ chối doanh nghiệp",
    resultsFound: {
      singular: "Đã tìm thấy 1 doanh nghiệp",
      plural: "Đã tìm thấy nhiều doanh nghiệp",
    },
    errors: {
      network:
        "Có vấn đề khi kết nối với dịch vụ tìm kiếm doanh nghiệp. Vui lòng thử lại sau.",
    },
  },
  explicitConsent: {
    label:
      "Bằng cách chọn hộp này, tôi chấp nhận các điều khoản sử dụng của Elanco và xác nhận rằng Elanco thu thập và xử lý dữ liệu cá nhân của tôi theo chính sách bảo mật của Elanco",
    errors: {
      required: "Yêu cầu sự đồng ý rõ ràng",
    },
  },
  telephone: {
    label: "Điện thoại cá nhân",
    placeholder: "Nhập số điện thoại cá nhân của bạn",
    dialCodeLabel: "Mã",
    dialCodePlaceholder: "Tìm kiếm quốc gia...",
    errors: {
      invalid: "Nhập số điện thoại hợp lệ.",
    },
  },
  businessTelephone: {
    label: "Điện thoại doanh nghiệp",
    placeholder: "Nhập số điện thoại doanh nghiệp",
    dialCodeLabel: "Mã",
    dialCodePlaceholder: "Tìm kiếm quốc gia...",
    errors: {
      invalid: "Nhập số điện thoại hợp lệ.",
    },
  },
  professionalNumber: {
    label: "Số chuyên nghiệp",
    placeholder: "1234567",
    errors: {
      required: "Nhập số chuyên nghiệp",
      maxLength: "Đầu vào vượt quá giới hạn ký tự",
    },
  },
  addressSearch: {
    errors: {
      required: "Trường này là bắt buộc",
    },
  },
  businessSearchField: {
    errors: {
      required: "Trường này là bắt buộc",
    },
  },
  checkbox: {
    errors: {
      required: "Trường này là bắt buộc",
    },
  },
  checkboxGroup: {
    errors: {
      required: "Trường này là bắt buộc",
    },
  },
  combobox: {
    errors: {
      required: "Trường này là bắt buộc",
    },
  },
  datePicker: {
    errors: {
      required: "Trường này là bắt buộc",
    },
  },
  dateRange: {
    errors: {
      required: "Trường này là bắt buộc",
    },
  },
  dateTime: {
    errors: {
      required: "Trường này là bắt buộc",
    },
  },
  emailField: {
    errors: {
      required: "Trường này là bắt buộc",
    },
  },
  fileInput: {
    errors: {
      required: "Chọn tệp",
    },
  },
  number: {
    errors: {
      required: "Nhập số",
      minValue: "Nhập giá trị lớn hơn giá trị tối thiểu",
      maxValue: "Nhập giá trị nhỏ hơn giá trị tối đa",
    },
  },
  passwordField: {
    errors: {
      required: "Trường này là bắt buộc",
    },
  },
  rangeSlider: {
    errors: {
      required: "Trường này là bắt buộc",
    },
  },
  select: {
    errors: {
      required: "Trường này là bắt buộc",
    },
  },
  telephoneField: {
    errors: {
      required: "Chỉ nhập số",
      invalidTelephone: "Nhập số điện thoại hợp lệ",
      invalidFormat: "Định dạng số không hợp lệ",
    },
  },
  text: {
    errors: {
      required: "Chỉ sử dụng chữ cái (A-Z), số (0-9) và không có ký hiệu",
      maxLength: "Đầu vào vượt quá giới hạn ký tự",
      minLength: "Đầu vào phải tối thiểu 2 ký tự",
    },
  },
  textarea: {
    characters: "ký tự",
  },
  time: {
    errors: {
      required: "Trường này là bắt buộc",
    },
  },
  form: {
    errors: {
      generic: "Lomakkeen lähettämisessä tapahtui virhe. Thử lại.",
      reportAnIssue: "Báo cáo sự cố.",
      configuration: "Lỗi cấu hình",
      noFormQuestionsAvailable: "Không có mục biểu mẫu.",
      formComponentLoad:
        "Không thể tải thành phần biểu mẫu do trường không được hỗ trợ.",
      code: "Mã",
      type: "Tyyppi",
      missingRequiredFields:
        "Biểu mẫu thiếu các trường bắt buộc (Email và/hoặc Đồng ý). Vui lòng liên hệ với quản trị viên để sửa cấu hình biểu mẫu.",
    },
  },
};

const ROLES = [
  { value: "Academic", label: "Academic", id: "academic" },
  {
    value: "Animal Welfare - Other",
    label: "Animal Welfare - Other",
    id: "animal_welfare_other",
  },
  {
    value: "Animal Welfare - Retail Staff",
    label: "Animal Welfare - Retail Staff",
    id: "animal_welfare_retail_staff",
  },
  {
    value: "Animal Welfare - Vet",
    label: "Phúc lợi động vật - Bác sĩ thú y",
    id: "animal_welfare_vet",
  },
  {
    value: "Animal Welfare - Vet Nurse",
    label: "Animal Welfare - Vet Nurse",
    id: "animal_welfare_vet_nurse",
  },
  {
    value: "Animal Welfare - Volunteer",
    label: "Animal Welfare - Volunteer",
    id: "animal_welfare_volunteer",
  },
  {
    value: "Beef / Feedlot Extension",
    label: "Beef / Feedlot Extension",
    id: "beef_feedlot_extension",
  },
  {
    value: "Beef Producer",
    label: "Beef Producer",
    id: "beef_producer",
  },
  { value: "Breeder", label: "Breeder", id: "breeder" },
  {
    value: "Business Administrator / Receptionist",
    label: "Business Administrator / Receptionist",
    id: "business_administrator_receptionist",
  },
  {
    value: "Business Owner / Partner",
    label: "Business Owner / Partner",
    id: "business_owner_partner",
  },
  {
    value: "Consulting Nutritionist",
    label: "Consulting Nutritionist",
    id: "consulting_nutritionist",
  },
  {
    value: "Corporate Employee Non DVM",
    label: "Corporate Veterinary Employee (non-hospital)",
    id: "corporate_employee_non_dvm",
  },
  {
    value: "Dairy Producer",
    label: "Dairy Producer",
    id: "dairy_producer",
  },
  { value: "Distributor", label: "Distributor", id: "distributor" },
  {
    value: "Distributor Rep, Field Based",
    label: "Distributor Rep, Field Based",
    id: "distributor_rep_field_based",
  },
  {
    value: "Distributor Rep, Inside",
    label: "Distributor Rep, Inside",
    id: "distributor_rep_inside",
  },
  {
    value: "Educational Institution - Highschool Student",
    label: "Educational Institute - Highschool Student",
    id: "educational_institution_highschool_student",
  },
  {
    value: "Educational Institution - TAFE Student",
    label: "Educational Institute - TAFE Student",
    id: "educational_institution_tafe_student",
  },
  {
    value: "Educational Institution - University Student",
    label: "Educational Institute - University Student",
    id: "educational_institution_university_student",
  },
  { value: "Groomer", label: "Groomer", id: "groomer" },
  {
    value: "Medical / Clinic Director",
    label: "Medical/Clinic Director",
    id: "medical_clinic_director",
  },
  {
    value: "Nutrition / Feed Sales",
    label: "Nutrition / Feed Sales",
    id: "nutrition_feed_sales",
  },
  {
    value: "Nutritional Professional",
    label: "Nutritional Professional",
    id: "nutritional_professional",
  },
  { value: "Nutritionist", label: "Nutritionist", id: "nutritionist" },
  {
    value: "Office / Practice Manager",
    label: "Office/Practice Manager",
    id: "office_practice_manager",
  },
  { value: "OTC Retailer", label: "OTC Retailer", id: "otc_retailer" },
  { value: "Pharmacist", label: "Pharmacist", id: "pharmacist" },
  {
    value: "Pharmacy - Staff",
    label: "Pharmacy - Staff",
    id: "pharmacy_staff",
  },
  { value: "Pig Producer", label: "Pig Producer", id: "pig_producer" },
  {
    value: "Poultry Producer",
    label: "Poultry Producer",
    id: "poultry_producer",
  },
  {
    value: "Practice Owner, Non DVM",
    label: "Practice Owner, Non DVM",
    id: "practice_owner_non_dvm",
  },
  {
    value: "Receptionist / Client Service",
    label: "Receptionist/Client Service",
    id: "receptionist_client_service",
  },
  {
    value: "Reseller Store - Staff",
    label: "Reseller Store - Staff",
    id: "reseller_store_staff",
  },
  { value: "SQP", label: "RAMA / SQP", id: "sqp" },
  { value: "Student RAMA", label: "Student RAMA", id: "student_rama" },
  {
    value: "Tierarzt/ Tierärztin",
    label: "Bác sĩ thú y",
    id: "tierarzt_tierarztin",
  },
  { value: "Trainer", label: "Trainer", id: "trainer" },
  { value: "Veterinarian", label: "Bác sĩ thú y", id: "veterinarian" },
  {
    value: "Veterinarian, Practice Owner",
    label: "Bác sĩ thú y, chủ phòng khám",
    id: "veterinarian_practice_owner",
  },
  {
    value: "Veterinary Assistant",
    label: "Trợ lý bác sĩ thú y",
    id: "veterinary_assistant",
  },
  {
    value: "Veterinary Nurse",
    label: "Veterinary Nurse",
    id: "veterinary_nurse",
  },
  {
    value: "Veterinary Practice - Other",
    label: "Phòng khám thú y - Muu",
    id: "veterinary_practice_other",
  },
  {
    value: "Veterinary Practice - Vet",
    label: "Phòng khám thú y - Bác sĩ thú y",
    id: "veterinary_practice_vet",
  },
  {
    value: "Veterinary Practice - Vet Nurse",
    label: "Phòng khám thú y - Eläinhoitaja",
    id: "veterinary_practice_vet_nurse",
  },
  {
    value: "Veterinary Specialist",
    label: "Chuyên gia thú y",
    id: "veterinary_specialist",
  },
  {
    value: "Veterinary Student",
    label: "Veterinary Student",
    id: "veterinary_student",
  },
  {
    value: "Veterinary Surgeon",
    label: "Bác sĩ thú y",
    id: "veterinary_surgeon",
  },
  {
    value: "Veterinary Technician",
    label: "Veterinary Technician",
    id: "veterinary_technician",
  },
  { value: "Wholesaler", label: "Wholesaler", id: "wholesaler" },
];

const SALUTATIONS = [
  {
    label: "Dr.",
    value: "Dr.",
    id: "dr",
  },
  {
    label: "Ông",
    value: "M.",
    id: "m",
  },
  {
    label: "Miss",
    value: "Miss",
    id: "miss",
  },
  {
    label: "Ông",
    value: "Mr.",
    id: "mr",
  },
  {
    label: "Bà",
    value: "Mrs.",
    id: "mrs",
  },
  {
    label: "Bà",
    value: "Ms.",
    id: "ms",
  },
  {
    label: "Mx.",
    value: "Mx.",
    id: "mx",
  },
  {
    label: "Giáo sư",
    value: "Professor",
    id: "professor",
  },
];

export { BUSINESS_TYPES, FIELDS, ROLES, SALUTATIONS };
